<template lang="pug">
#reservation-list(v-cloak)
  .box
    .box-header(v-if="_showHeader")
      .d-flex
        .note
          span 面会の設定と予約状況を確認できます。ご家族の予約に「承諾」を選択すると予約完了になります。
        .d-flex.flex-fill.justify-content-end.flex-wrap
          //- 基本設定
          button.btn.setting-btn.mr-2(v-if="_showSettingsButton" @click="goToSettings") 基本設定
          button.btn.setting-btn.mr-2.disable(v-else) 基本設定
          //- スケジュール・代理予約
          button.btn.schedule-btn.mr-2(v-if="_showSchedulesButton" @click="goToSchedules") スケジュール・代理予約
          button.btn.schedule-btn.mr-2.disable(v-else disabled) スケジュール・代理予約
      span.error-message(v-if="errorMessage") {{ errorMessage }}

    .box-body
      ReservationTable.reservation-table(
        v-model="items"
        :fields="fields"
        :totalRows.sync="_rows"
        :currentPage.sync="currentPage"
        :perPage="perPage"
        :isLoading="isLoading"
        :filter="filter"
        :allSelect.sync="allSelects[Number(currentPage) - 1]"
        :visitSetting="visitSetting"
        @onAllSelect="changeAllSelect"
        @onEditLocation="onEditLocation"
        @onEditText="onEditText"
        @onConsented="confirmConsented"
        @onUnconsented="onUnconsented"
        @onConsentedCancel="onConsentedCancel"
        @onSendOther="showMessageTargetModal"
      )
      .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap
        //- 一括承諾
        .flex-fill(v-if="_useEditReservations")
          button.btn.multiple-consented-btn#multiple-consented-btn(@click="onMultipleConsented" :class="{ disable: disableMultipleConsented }") 一括承諾
          b-popover(target="multiple-consented-btn" triggers="hover")
            .d-flex.flex-column
              span チェックを付けた面会予約を一括で承諾することができます。一番上のチェックを選択すると、全件にチェックを付けたり外したりできます。
        //- 削除済みを表示
        .deleted-filter.mr-2
          b-form-checkbox(v-model="filter.showCanceled") キャンセル済を表示
        //- 検索
        .word-search-filter.search-filter.d-flex.mr-1.align-items-center.mr-2
          b-input-group.search-filter-input-group.mr-1(size="md")
            b-input-group-prepend
              b-input-group-text.search-filter-icon
                .search-icon
            b-form-input.search-filter-input(v-model="filter.searchWord" type="search" placeholder="検索ワードを入力してください")
          HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="search-filter-help" title="検索項目について")
            template(v-slot:text)
              div 検索項目は以下になります。
              div ・利用者名
              div ・利用者名（ふりがな）※
              div ・部屋名
              div ・面会者名
              div ※ 利用者情報にふりがなを登録前の面会予約はふりがな検索ができません。
        //- フィルタリング
        .resident-group-filter.d-flex.align-items-center
          span.table-option-text 利用者グループ:
          .filter
            b-form-select(id="filter-input" v-model="filter.id" :options="filterOptions" size="md")
        //- ページあたりの行数
        span.table-option-text 1ページの行数:
        .per-page
          b-form-select(id="per-page-select" v-model="perPage" :options="pageOptions" size="md" @change="selectPerPage")
        //- ページネーション
        b-pagination.m-0(v-model="currentPage" :total-rows="_rows" :per-page="perPage" :disabled="isLoading" @change="selectPage" hide-goto-end-buttons)

  OkCancelModal(v-model="showConsentedRegisterModal" :title="modalMessage" @ok="consented")
  OkModal(v-model="showConsentedSuccessModal" title="承諾しました。")

  OkCancelModal(v-model="showConsentedCancelRegisterModalByNoMessage" :title="modalMessage" :message="modalOptionMessage" @ok="consentedCancel")
  MessageModal(v-model="showConsentedCancelRegisterModal" :modalTitle="messageModalTitle" :modalMessage="messageModalMessage"
    :title.sync="messageTitle" :text.sync="messageText" @onSend="confirmConsentedCancel")
  MessageConfirmModal(v-model="showConsentedCancelRegisterConfirmModal" :modalTitle="messageConfirmModalTitle" :title="messageTitle" :text="messageText"
    @onSend="consentedCancel")
  OkCancelModal(v-model="showConfirmCancelModal" title="家族ユーザーが削除されている面会予約ですが、キャンセルしますか？" @ok="consentedCancel")
  OkModal(v-model="showConsentedCancelSuccessModal" title="キャンセルしました。")

  MessageModal(v-model="showUnconsentedRegisterModal" :modalTitle="messageModalTitle" :modalMessage="messageModalMessage"
    :title.sync="messageTitle" :text.sync="messageText" @onSend="confirmUnconsented")
  MessageConfirmModal(v-model="showUnconsentedRegisterConfirmModal" :modalTitle="messageConfirmModalTitle" :title="messageTitle" :text="messageText"
    @onSend="unconsented")
  OkCancelModal(v-model="showConfirmUnconsentedModal" title="家族ユーザーが削除されている面会予約ですが、辞退しますか？" @ok="unconsented")
  OkModal(v-model="showUnconsentedSuccessModal" title="辞退しました。")

  TransferOnlineReservationSelectModal(ref="transferOnlineReservationSelectModal" v-model="targets" @add="addSendTarget")
  TransferOnlineReservationModal(v-model="registerTarget" :reservation.sync="updateTargetReservation" @register="sendMessage" ref="sendMessageModal")
  OkModal(v-model="showSendMessageSuccessModal" title="オンライン面会の案内を受け付けました。")

  EditLocationModal(v-model="showEditLocationModal" @ok="confirmEditLocation")
  OkCancelModal(v-model="showConfirmEditLocationModal" :title="confirmEditLocationModalTitle" @ok="updateLocation")
  OkModal(v-model="showSuccessEditLocationModal" title="面会場所を更新しました。")

  EditTextModal(v-model="showEditTextModal" :modalTitle="editTextModalTitle" :text.sync="editTextModalText" @ok="confirmEditText")
  EditTextConfirmModal(v-model="showConfirmEditTextModal" :modalTitle="editTextConfirmModalTitle" :text="editTextModalText" @ok="updateText")
  OkModal(v-model="showSuccessEditTextModal" title="家族からの連絡事項を更新しました。")

  MultipleConsentedModal(v-model="showMultipleConsentedModal" :items="multipleConsentedTargets" @ok="multipleConsented")
  ProgressLoading(v-model="currentConsentedCount" :max="consentedCount" :isBusy="progressLoading" :message="progressMessage")
  OkModal(v-model="showMultipleConsentedSuccessModal" title="一括承諾が完了しました。")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { userStore, itemListFilterStore } from "@/store/store";
import { errorHandle } from "@/errorHandler";

import Setting from "../../../../public/setting.json";
import { PcUrl } from "@/commons/constants/PcUrl";
import SystemError from "@/commons/models/SystemError";
import ReservationsService, {
  InputType,
  ReservationDeleteSendType,
  ReservationsDeleteModel,
  ReservationsGetModel,
  ReservationsConsentedPatchModel,
  ReservationType,
  ReservationsPatchModel
} from "@/commons/services/Reservations";
import ReservationSettingsService, { ReservationSettingsGetModel } from "@/commons/services/ReservationSettings";
import OnlineReservationSettingsService, { OnlineReservationSettingsGetModel } from "@/commons/services/OnlineReservationSettings";
import OtherUserGroupTypeMembersService, { OtherUserGroupTypeGroup } from "@/commons/services/OtherUserGroupTypeMembers";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import FamiliesService, { FamilyGetModel, SenderType } from "@/commons/services/Families";

import HelpIcon from "@/pc/basics/HelpIcon.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import ReservationTable, { FilterSetting, ReservationTableField, ReservationTableItem } from "@/pc/containers/reservations/ReservationTable.vue";
import TransferOnlineReservationSelectModal from "@/pc/components/modals/TransferOnlineReservationSelectModal.vue";
import TransferOnlineReservationModal from "@/pc/components/modals/TransferOnlineReservationModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import MessageModal from "@/pc/containers/reservations/MessageModal.vue";
import MessageConfirmModal from "@/pc/containers/reservations/MessageConfirmModal.vue";
import EditLocationModal from "@/pc/containers/reservations/EditLocationModal.vue";
import EditTextModal from "@/pc/containers/reservations/EditTextModal.vue";
import EditTextConfirmModal from "@/pc/containers/reservations/EditTextConfirmModal.vue";
import MultipleConsentedModal from "@/pc/containers/reservations/MultipleConsentedModal.vue";
import ProgressLoading from "@/pc/basics/ProgressLoading.vue";

/** ナビゲーションガードのフックを使えるようにする */
Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    ReservationTable,
    OkCancelModal,
    OkModal,
    TransferOnlineReservationSelectModal,
    TransferOnlineReservationModal,
    HelpIcon,
    MessageModal,
    MessageConfirmModal,
    EditLocationModal,
    EditTextModal,
    EditTextConfirmModal,
    MultipleConsentedModal,
    ProgressLoading,
    PageLoading
  }
})
export default class ReservationList extends Vue {
  /** 面会予約サービス */
  @Inject("ReservationsService") reservationsService!: ReservationsService;
  /** 施設関係者グループ種類にひもづくメンバー取得サービス */
  @Inject("OtherUserGroupTypeMembersService") otherUserGroupTypeMembersService!: OtherUserGroupTypeMembersService;
  /** 訪問面会設定サービス */
  @Inject("ReservationSettingsService") reservationSettingsService!: ReservationSettingsService;
  /** オンライン面会設定サービス */
  @Inject("OnlineReservationSettingsService") onlineReservationSettingsService!: OnlineReservationSettingsService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** 家族ユーザーサービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 承諾完了確認モーダル表示可否 */
  showConsentedRegisterModal: boolean = false;
  /** 承諾完了モーダル表示可否 */
  showConsentedSuccessModal: boolean = false;

  /** 辞退メッセージ入力モーダル表示可否 */
  showUnconsentedRegisterModal: boolean = false;
  /** 辞退メッセージ確認モーダル表示可否 */
  showUnconsentedRegisterConfirmModal: boolean = false;
  /** 辞退完了モーダル表示可否 */
  showUnconsentedSuccessModal: boolean = false;
  /** キャンセル確認モーダル表示可否 */
  showConsentedCancelRegisterModalByNoMessage: boolean = false;
  /** キャンセルメッセージ入力モーダル表示可否 */
  showConsentedCancelRegisterModal: boolean = false;
  /** キャンセルメッセージ確認モーダル表示可否 */
  showConsentedCancelRegisterConfirmModal: boolean = false;
  /** キャンセル完了モーダル表示可否 */
  showConsentedCancelSuccessModal: boolean = false;
  /** メッセージ入力モーダルのタイトル */
  messageModalTitle: string = "";
  /** メッセージ入力モーダルのメッセージ */
  messageModalMessage: string = "";
  /** メッセージタイトル */
  messageTitle: string = "";
  /** メッセージ本文 */
  messageText: string = "";
  /** メッセージ入力確認モーダルのタイトル */
  messageConfirmModalTitle: string = "";
  /** 家族が削除されたいた場合の辞退の確認モーダル */
  showConfirmUnconsentedModal: boolean = false;
  /** 家族が削除されたいた場合のキャンセルの確認モーダル */
  showConfirmCancelModal: boolean = false;

  /** オンライン面会の案内完了モーダル表示可否 */
  showSendMessageSuccessModal: boolean = false;

  /** 面会予約列名 */
  fields: Array<ReservationTableField> = [];
  /** 面会予約各行の情報 */
  items: Array<ReservationTableItem> = [];
  /** テーブルの「選択」列のチェックボックス値 */
  allSelects: boolean[] = [];
  /** テーブルのローディング表示可否 */
  isLoading: boolean = true;
  /** 更新対象の面会予約 */
  updateTargetReservation: ReservationTableItem | null = null;
  /** 更新対象の家族 */
  updateTargetFamily: FamilyGetModel | null = null;
  /** 利用者グループMAP */
  groupIdMap: Map<number, ResidentGroupsGetModel> = new Map<number, ResidentGroupsGetModel>();

  /** 宛先 */
  targets: Array<OtherUserGroupTypeGroup> = [];
  /** 一時保持する登録対象の家族ユーザー */
  registerTarget: OtherUserGroupTypeGroup | any = {};
  /** モーダル表示のメッセージ */
  modalMessage: string = "";
  /** モーダルオプションメッセージ */
  modalOptionMessage: string = "";
  /** エラーメッセージ */
  errorMessage: string = "";

  /** 訪問面会設定 */
  visitSetting: ReservationSettingsGetModel | null = null;
  /** オンライン面会設定 */
  onlineSetting: OnlineReservationSettingsGetModel | null = null;

  /** 面会場所編集対象の行情報 */
  editLocationTargetItem: ReservationTableItem | null = null;
  /** 面会場所編集モーダル表示可否 */
  showEditLocationModal: boolean = false;
  /** 面会場所編集確認モーダル表示可否 */
  showConfirmEditLocationModal: boolean = false;
  /** 面会場所編集確認モーダルタイトル */
  confirmEditLocationModalTitle: string = "";
  /** 更新後面会場所 */
  newLocation: string = "";
  /** 面会場所編集完了モーダル表示可否 */
  showSuccessEditLocationModal: boolean = false;

  /** 連絡事項編集モーダル表示可否 */
  showEditTextModal: boolean = false;
  /** 連絡事項編集モーダルのタイトル */
  editTextModalTitle: string = "";
  /** 編集対象の連絡事項 */
  editTextModalText: string = "";
  /** 連絡事項編集対象の行情報 */
  editTextTargetItem: ReservationTableItem | null = null;
  /** 連絡事項編集確認モーダル表示可否 */
  showConfirmEditTextModal: boolean = false;
  /** 連絡事項編集確認モーダルのタイトル */
  editTextConfirmModalTitle: string = "";
  /** 連絡事項編集成功モーダル表示可否 */
  showSuccessEditTextModal: boolean = false;

  /** 一括承諾ボタンの非活性 */
  disableMultipleConsented: boolean = true;
  /** 一括承諾確認モーダル表示可否 */
  showMultipleConsentedModal: boolean = false;
  /** 一括承諾確認対象の面会予約 */
  multipleConsentedTargets: Array<ReservationTableItem> = [];
  /** 現在の一括承諾数 */
  currentConsentedCount: number = 0;
  /** 一括承諾数最大値 */
  consentedCount: number = 0;
  /** プログレス付きローディング表示可否 */
  progressLoading: boolean = false;
  /** プログレス付きローディングメッセージ */
  progressMessage: string = "";
  /** 一括承諾完了モーダル表示可否 */
  showMultipleConsentedSuccessModal: boolean = false;

  /** フィルタリング条件 */
  filter: FilterSetting = { searchWord: "", id: "", showCanceled: false };
  /** フィルター選択項目 */
  filterOptions: Array<{ value: string; text: string }> = [];
  /** ページングの現在ページ番号 */
  currentPage: number = 1;
  /** ページングの全体行数 */
  rows: number = 0;
  /** 1ページに表示する行数 */
  perPage: number = Number(Setting.reservation.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.reservation.pageOptions;

  /**
   * ### 一括承諾ボタンの活性／非活性を切り替えるためにitemsを監視する
   */
  @Watch("items", { deep: true })
  changeItems(newValue: Array<ReservationTableItem>): void {
    for (const item of newValue) {
      if (item.select == true) {
        this.disableMultipleConsented = false;
        return;
      }
    }
    this.disableMultipleConsented = true;
    return;
  }

  /** ### 面会予約編集可否 */
  get _useEditReservations(): boolean {
    return userStore.user.permissions.reservationsFunction.useEditReservations;
  }

  /**
   * ### 設定ボタンの活性表示可否
   */
  get _showSettingsButton(): boolean {
    const permittedReservation: boolean = userStore.facility.permittedFunctions.reservation;
    const useReservationSettings: boolean = userStore.user.permissions.reservationsFunction.useReservationSettings;

    const permittedOnlineReservation: boolean = userStore.facility.permittedFunctions.onlineReservation;
    const useOnlineReservationSettings: boolean = userStore.user.permissions.reservationsFunction.useOnlineReservationSettings;

    // 面会予約設定使用可能
    if (permittedReservation && useReservationSettings) {
      return true;
    }
    // オンライン面会予約使用可能
    else if (permittedOnlineReservation && useOnlineReservationSettings) {
      return true;
    }
    // その他
    else {
      return false;
    }
  }

  /**
   * ### 面会日時ボタンの活性表示可否
   */
  get _showSchedulesButton(): boolean {
    const useReserveInstead: boolean = userStore.user.permissions.reservationsFunction.useReserveInstead;

    const permittedReservation: boolean = userStore.facility.permittedFunctions.reservation;
    const useReservationSchedules: boolean = userStore.user.permissions.reservationsFunction.useReservationSchedules;
    const useSchedule: boolean = this.visitSetting && this.visitSetting.reservationInputType == 1 ? true : false;

    const permittedOnlineReservation: boolean = userStore.facility.permittedFunctions.onlineReservation;
    const useOnlineReservationSchedules: boolean = userStore.user.permissions.reservationsFunction.useOnlineReservationSchedules;

    // 代理予約使用可能
    if ((permittedReservation || permittedOnlineReservation) && useReserveInstead) {
      return true;
    }
    // 訪問面会スケジュール使用可能
    else if (permittedReservation && useReservationSchedules && useSchedule) {
      return true;
    }
    // オンライン面会スケジュール使用可能
    else if (permittedOnlineReservation && useOnlineReservationSchedules) {
      return true;
    }
    // それ以外
    else {
      return false;
    }
  }

  /**
   * ### ヘッダー部の表示可否
   */
  get _showHeader(): boolean {
    if (userStore.facility.permittedFunctions.reservation || userStore.facility.permittedFunctions.onlineReservation) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### 行数を返す
   *
   * - キャンセル済みを表示する場合は全体件数を返す
   * - キャンセル済みを表示しない場合は削除されていない行の件数を返す
   */
  get _rows(): number {
    let rows = 0;
    if (this.filter.showCanceled == true) {
      return this.rows;
    } else {
      for (const item of this.items) {
        if (item.deleteFlag == false) {
          rows++;
        }
      }
      return rows;
    }
  }
  //** setterがないと警告が出るので対応 */
  set _rows(newValue: number) {
    return;
  }

  /**
   * ### 1ページあたりの表示行数の変更イベント
   *
   * - 変更をクッキーに持たせる
   */
  @Watch("perPage")
  public changePerPage(perPage: number): void {
    this.setCookie(perPage);
    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  public setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `reservation-list-per-page=${perPage}; max-age=${saveSecond};`;
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    // 列名の表示可否を判断するために設定は最初に取得する
    const visitSetting: ReservationSettingsGetModel = await this.getReservationSetting();
    this.visitSetting = visitSetting;
    const onlineSetting: OnlineReservationSettingsGetModel = await this.getOnlineReservationSetting();
    this.onlineSetting = onlineSetting;

    // 画面初期表示時に作成して変更しないものを初期化する
    const fields: Array<ReservationTableField> = this.createReservationFields();
    this.fields = fields;
    // 1ページあたりの表示行数はCookieから取得する。取得できない場合はデフォルト値を使用する
    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.reservation.perPage);
    // フィルタの復元
    this.restoreFilterSetting();

    const targets: Array<OtherUserGroupTypeGroup> = await this.createTransferTargets();
    this.targets = targets;

    const groups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const groupIdMap: Map<number, ResidentGroupsGetModel> = this.createGroupIdMap(groups);
    this.groupIdMap = groupIdMap;
    const filterOptions: Array<{ value: string; text: string }> = await this.createFilterOptions(groups);
    this.filterOptions = filterOptions;

    // 動的に変更する画面情報を作成する
    this.items = [];
    this.currentPage = 1;

    await this.createView();

    return;
  }

  /**
   * ### 訪問面会設定を取得する
   */
  public async getReservationSetting(): Promise<ReservationSettingsGetModel> {
    const response: ReservationSettingsGetModel = await this.reservationSettingsService.get(userStore);
    return response;
  }

  /**
   * ### オンライン面会設定を取得する
   */
  public async getOnlineReservationSetting(): Promise<OnlineReservationSettingsGetModel> {
    const response: OnlineReservationSettingsGetModel = await this.onlineReservationSettingsService.get(userStore);
    return response;
  }

  /**
   * ### 面会予約の列を作成する
   */
  public createReservationFields(): Array<ReservationTableField> {
    let fields: Array<ReservationTableField> = [];
    // 列の追加をしているか否か（追加している場合と追加していない場合で操作列のボタン文字サイズを変更する）
    let added = false;

    // 権限で面会予約の操作が可の場合は列を表示する
    if (this._useEditReservations) {
      fields.push({ key: "select", label: "選択", sortable: false, sortDirection: "desc", class: "text-center select" });
    }
    fields.push({ key: "type", label: "種別", sortable: false, sortDirection: "desc", class: "text-center type" });
    fields.push({ key: "inputTypeAndStatus", label: "", sortable: false, sortDirection: "desc", class: "text-center input-type-and-status" });
    fields.push({ key: "datetime", label: "面会日時", sortable: false, sortDirection: "desc", class: "date" });

    // 「訪問面会を使用している」かつ「訪問面会の面会場所」を使用している場合は、面会場所を追加
    if (userStore.facility.permittedFunctions.reservation == true && this.visitSetting && this.visitSetting.useLocation == true) {
      fields.push({ key: "location", label: "面会場所", sortable: false, sortDirection: "desc", class: "location" });
      added = true;
    }

    fields.push({ key: "resident", label: "利用者名（部屋名）", sortable: false, sortDirection: "desc", class: "resident" });
    fields.push({ key: "familyNameAndTel", label: "面会者名（続柄）電話番号", sortable: false, sortDirection: "desc", class: "family-and-tel" });

    // 「訪問面会」と「オンライン面会」を使用していて、「家族からの連絡事項」を「使用している」ものがあれば、家族からの連絡事項を追加
    if (
      (userStore.facility.permittedFunctions.reservation == true && this.visitSetting && this.visitSetting.useText == true) ||
      (userStore.facility.permittedFunctions.onlineReservation == true && this.onlineSetting && this.onlineSetting.useText == true)
    ) {
      fields.push({ key: "text", label: "家族からの連絡事項", sortable: false, sortDirection: "desc", class: "text" });
      added = true;
    }

    // 追加項目がある場合はCSSクラスを追加する
    // 追加したクラスのCSS指定はReservationList.vueでv-deepを使用して指定している
    const buttonSizeClass = added ? " small-buttons" : "";
    fields.push({ key: "reply", label: "返信", sortable: false, sortDirection: "desc", class: `text-center reply${buttonSizeClass}` });
    fields.push({ key: "controll", label: "操作", sortable: false, sortDirection: "desc", class: `text-center controll${buttonSizeClass}` });

    return fields;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = cookieMap["reservation-list-per-page"];

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  /** フィルタ情報がstoreに存在する場合は復元する */
  private restoreFilterSetting(): void {
    if (this.$options.name && itemListFilterStore.filterMap[this.$options.name] != undefined) {
      this.filter = itemListFilterStore.filterMap[this.$options.name];
    }
    return;
  }

  /**
   * ### 宛先対象リストを作成する
   *
   */
  public async createTransferTargets(): Promise<Array<OtherUserGroupTypeGroup>> {
    const targets: Array<OtherUserGroupTypeGroup> = await this.otherUserGroupTypeMembersService.get(userStore, 1);
    return targets;
  }

  /**
   * ### 全ての利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者グループマスターのMAPを作る
   */
  public createGroupIdMap(residentGroups: Array<ResidentGroupsGetModel>): Map<number, ResidentGroupsGetModel> {
    let map: Map<number, ResidentGroupsGetModel> = new Map<number, ResidentGroupsGetModel>();
    for (const group of residentGroups) {
      map.set(group.id, group);
    }

    return map;
  }

  /**
   * ### 利用者グループフィルター用選択項目
   *
   * - アカウント情報から許可されている利用者グループIDの配列を取得する
   * - 利用者グループマスターと照合して選択項目の利用者グループを作成する
   */
  public createFilterOptions(residentGroups: Array<ResidentGroupsGetModel>): Array<{ value: string; text: string }> {
    const filterOptions: Array<{ value: string; text: string }> = [];

    filterOptions.push({
      value: "",
      text: "全て"
    });

    const allowedGroupsMap: Map<number, number> = new Map<number, number>();
    for (const allowedGroup of userStore.loginUser.permissions.residentGroups) {
      allowedGroupsMap.set(allowedGroup, allowedGroup);
    }
    for (const group of residentGroups) {
      if (allowedGroupsMap.has(group.id)) {
        filterOptions.push({
          value: `${group.id}`,
          text: group.name
        });
      }
    }

    return filterOptions;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    this.isLoading = true;

    // 全体の行数を非同期で取得する
    this.setRows();

    // 面会予約テーブルに渡す各プロパティを作成する
    const reservations: Array<ReservationsGetModel> = await this.getReservations();
    const items: Array<ReservationTableItem> = this.createReservationItems(reservations, this.groupIdMap);

    // 各ページの全件チェック配列を作成する
    this.allSelects = this.createAllSelects(items);

    // 各ページの全件チェック配列が出来上がってから行情報は子コンポーネントに渡す
    this.items = items;

    this.isLoading = false;

    return;
  }

  /**
   * ### ページング用の全件数を設定する
   */
  public async setRows() {
    try {
      // 検索条件が指定されている場合は、その検索条件を使用し、無ければデフォルトを使用する
      let params: any = {};
      // 過去の面会予約は表示対象外にするため、開始日時を指定する
      const start: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyymmdd000000000"); // 表示対象の利用者を取得する
      params = {
        start: start,
        needDeleted: "true"
      };

      const count: number = await this.reservationsService.getCount(userStore, params);

      this.rows = count;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    }

    return;
  }

  /**
   * ### 訪問予約を取得する
   */
  public async getReservations(): Promise<Array<ReservationsGetModel>> {
    let params: any = {};
    // 過去の面会予約は表示対象外にするため、開始日時を指定する
    const start: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyymmdd000000000"); // 表示対象の利用者を取得する
    params = {
      start: start,
      sortKey: "datetime",
      order: "asc",
      needDeleted: "true"
    };

    const response: Array<ReservationsGetModel> = await this.reservationsService.gets(userStore, params);

    return response;
  }

  /**
   * ### 面会予約の行を作成する
   */
  public createReservationItems(reservations: Array<ReservationsGetModel>, map: Map<number, ResidentGroupsGetModel>): Array<ReservationTableItem> {
    let items: Array<ReservationTableItem> = [];

    for (const reservation of reservations) {
      const group: ResidentGroupsGetModel | undefined = map.get(reservation.groupId);

      items.push({
        id: reservation.id,
        type: reservation.type,
        inputType: reservation.inputType,
        consented: reservation.consented ? reservation.consented : false,
        datetime: Number(reservation.datetime),
        resident: {
          id: reservation.residentId,
          name: reservation.residentName,
          kanaName: reservation.residentKanaName,
          room: reservation.residentRoom
        },
        family: {
          name: reservation.familyName,
          relation: reservation.familyRelation,
          position: reservation.familyPosition,
          id: reservation.familyId
        },
        location: reservation.location ? reservation.location : "",
        tel: reservation.familyTel,
        text: reservation.text ? reservation.text : "",
        status: reservation.consented ? reservation.consented : false,
        onlineVisitUrl: reservation.onlineVisitUrl ? reservation.onlineVisitUrl : "",
        updated: Number(reservation.updated),
        groupId: reservation.groupId,
        groupName: group ? group.name : "",
        deleteFlag: reservation.deleteFlag,
        /** 選択 */
        select: false,
        /** 行の設定 */
        _rowVariant: reservation.deleteFlag ? "gray-dark" : undefined
      });
    }

    return items;
  }

  /**
   * ### テーブルの選択列のチェックを作成する
   */
  public createAllSelects(items: Array<ReservationTableItem>): boolean[] {
    let allSelects: boolean[] = [];
    let pagesItems: Array<Array<ReservationTableItem>> = [];
    let pageCount = Math.ceil(items.length / this.perPage);
    for (var i = 0; i < pageCount; i++) {
      let start = i * this.perPage;
      let end = start + this.perPage;
      let chunk = items.slice(start, end);
      pagesItems.push(chunk);
    }

    for (const pageItems of pagesItems) {
      let select: boolean = true;
      for (const item of pageItems) {
        if (item.consented == true) {
          continue;
        }
        if (item.select == false) {
          select = false;
        }
      }
      allSelects.push(select);
    }

    return allSelects;
  }

  /**
   * ### 1ページあたりの表示行数変更イベント
   *
   * - 1ページあたりの表示行数を更新
   * - ページあたりの表示行数が変わるので表の情報を作り直す
   */
  public async selectPerPage(perPage: number): Promise<void> {
    this.perPage = perPage;
    this.currentPage = 1;
    this.allSelects = this.createAllSelects(this.items);
    return;
  }

  /**
   * ### ページネーションのページ番号押下
   */
  public async selectPage(page: number): Promise<void> {
    this.currentPage = page;
    return;
  }

  /**
   * ### 面会予約設定画面へ遷移する
   */
  public goToSettings(): void {
    this.$router.push(PcUrl.ReservationSettings);
    return;
  }

  /**
   * ### 面会スケジュール設定、代理予約画面へ遷移する
   */
  public goToSchedules(): void {
    this.$router.push(PcUrl.ReservationSchedules);
    return;
  }

  /**
   * ### 全て選択押下イベント
   */
  public changeAllSelect(): void {
    const start: number = (Number(this.currentPage) - 1) * Number(this.perPage);
    const end: number = Number(start) + Number(this.perPage);
    for (let i = start; i < end; i++) {
      if (this.items[i] && this.items[i].consented == false) {
        this.items[i].select = this.allSelects[Number(this.currentPage) - 1];
      }
    }
    return;
  }

  onEditLocation(item: ReservationTableItem): void {
    this.editLocationTargetItem = item;
    this.showEditLocationModal = true;
    return;
  }

  confirmEditLocation(newLocation: string): void {
    this.confirmEditLocationModalTitle = `面会場所を${newLocation}に変更します。よろしいですか？`;
    this.newLocation = newLocation;
    this.showConfirmEditLocationModal = true;
    return;
  }

  async updateLocation(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      // モーダル側で非表示にしないのでここで非表示にする
      this.showEditLocationModal = false;
      this.showConfirmEditLocationModal = false;

      // 更新情報を作成し、APIにリクエストを送る
      const reservation: ReservationTableItem = this.editLocationTargetItem as ReservationTableItem;
      const requestBody: ReservationsPatchModel = {
        location: this.newLocation,
        updated: Number(reservation.updated)
      };
      await this.reservationsService.patch(userStore, reservation.id, requestBody);

      this.isBusy = false;
      this.showSuccessEditLocationModal = true;

      // ページに表示する面会予約を取得しなおす
      this.items = [];
      await this.createView();
    } catch (error) {
      const systemError: SystemError = error as SystemError;

      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      } else if (systemError.statusCode == 400 && 0 < systemError.originalResponse.indexOf("over location.concurrentNumberLimit")) {
        this.errorMessage = "面会場所の同時予約可能数を超えるため予約できません。他の日時または他の面会場所を指定してください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw systemError;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 連絡事項編集モーダルを表示する
   */
  public onEditText(item: ReservationTableItem): void {
    this.editTextTargetItem = item;
    this.editTextModalTitle = `${item.resident.name}（${item.resident.room}）様の${item.family.name}（${item.family.relation}）の面会予約の連絡事項の編集`;
    this.editTextModalText = item.text ? item.text : "";
    this.showEditTextModal = true;
    return;
  }

  /**
   * ### 連絡事項確認モーダルを表示する
   */
  public confirmEditText(): void {
    const item: ReservationTableItem = this.editTextTargetItem as ReservationTableItem;
    this.editTextConfirmModalTitle = `${item.resident.name}（${item.resident.room}）様の${item.family.name}（${item.family.relation}）の面会予約の連絡事項を更新します。よろしいですか？`;
    this.showConfirmEditTextModal = true;
    return;
  }

  /**
   * ### 面会予約(連絡事項)を更新する
   */
  public async updateText(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      // モーダル側で非表示にしないのでここで非表示にする
      this.showEditTextModal = false;
      this.showConfirmEditTextModal = false;

      // 更新情報を作成し、APIにリクエストを送る
      const reservation: ReservationTableItem = this.editTextTargetItem as ReservationTableItem;
      const requestBody: ReservationsPatchModel = {
        text: this.editTextModalText ? this.editTextModalText : "",
        updated: Number(reservation.updated)
      };
      await this.reservationsService.patch(userStore, reservation.id, requestBody);

      this.isBusy = false;
      this.showSuccessEditTextModal = true;

      // ページに表示する面会予約を取得しなおす
      this.items = [];
      await this.createView();
    } catch (error) {
      const systemError: SystemError = error as SystemError;

      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw systemError;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 承諾確認ダイアログを表示する
   */
  public confirmConsented(reservation: ReservationTableItem): void {
    const message: string = `${reservation.resident.name}（${reservation.resident.room}）様の${reservation.family.name}（${reservation.family.relation}）の面会予約を承諾しますか？`;
    this.modalMessage = message;

    this.updateTargetReservation = reservation;
    this.showConsentedRegisterModal = true;

    return;
  }

  /**
   * ### 承諾をAPI経由で登録する
   */
  public async consented(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "承諾中...";

    try {
      // 登録用情報を作成し、APIにリクエストを送る
      const reservation: ReservationTableItem = this.updateTargetReservation as ReservationTableItem;
      const requestBody: ReservationsConsentedPatchModel = {
        consented: true,
        consentedUserId: userStore.loginUser.userId,
        consentedUserName: userStore.loginUser.name,
        updated: Number(reservation.updated)
      };
      await this.reservationsService.patchConsented(userStore, reservation.id, requestBody);

      this.isBusy = false;
      this.showConsentedSuccessModal = true;

      // サイドメニューの未完了バッジを更新する
      this.$emit("refresh");

      // ページに表示する面会予約を取得しなおす
      this.items = [];
      await this.createView();
    } catch (error) {
      const systemError: SystemError = error as SystemError;

      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw systemError;
      }
    }

    return;
  }

  /**
   * ### 承諾キャンセルのメッセージ入力ダイアログを表示する
   *
   * - 家族IDが0(代理予約ではないか、登録済み家族の代理予約ではない)であればモーダルに追加メッセージを表示する
   */
  public async onConsentedCancel(reservation: ReservationTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.updateTargetReservation = reservation;

    // 代理予約の場合はメッセージモーダルではなく既存のモーダルを表示する
    if (reservation.family.id == 0 && reservation.inputType == InputType.FACILITY_APP) {
      this.modalMessage = `${reservation.resident.name}（${reservation.resident.room}）様の${reservation.family.name}（${reservation.family.relation}）の面会予約をキャンセルしますか？`;
      this.modalOptionMessage = "登録されていないご家族の面会予約のため、キャンセル自動通知がありません。お電話でのご連絡をお願いします。";
      this.messageTitle = "";
      this.messageText = "";

      this.isBusy = false;
      this.showConsentedCancelRegisterModalByNoMessage = true;
    }
    // 代理予約以外の場合はメッセージモーダルを表示する
    else {
      // 家族が存在する場合、LINEまたはメールを送信するので入力モーダルを表示する
      const family: FamilyGetModel | null = await this.getFamily(reservation.resident.id, reservation.family.id);
      if (family) {
        this.updateTargetFamily = family;
        this.setMessageModalTitleAndText(family, reservation, "キャンセル");

        this.isBusy = false;
        this.showConsentedCancelRegisterModal = true;
      }
      // 家族が削除されていた場合、辞退・キャンセルの確認モーダルを表示する
      else {
        this.isBusy = false;
        this.showConfirmCancelModal = true;
      }
    }

    return;
  }

  /**
   * ### 承諾キャンセル確認ダイアログを表示する
   */
  public confirmConsentedCancel(): void {
    const reservation: ReservationTableItem = this.updateTargetReservation as ReservationTableItem;
    this.messageConfirmModalTitle = `${reservation.resident.name}（${reservation.resident.room}）様の`;
    this.messageConfirmModalTitle += `${reservation.family.name}（${reservation.family.relation}）に以下の内容でメッセージを送信します。よろしいですか？`;
    this.showConsentedCancelRegisterConfirmModal = true;
    return;
  }

  /**
   * ### 承諾キャンセルをAPI経由で登録する
   */
  public async consentedCancel(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "キャンセル中...";

    this.showConsentedCancelRegisterConfirmModal = false;
    this.showConsentedCancelRegisterModal = false;

    const reservation: ReservationTableItem = this.updateTargetReservation as ReservationTableItem;
    let requestBody: ReservationsDeleteModel | null = null;
    if (reservation.family.id == 0 && reservation.inputType == InputType.FACILITY_APP) {
      requestBody = this.createDeleteRequestBody(ReservationDeleteSendType.NONE, reservation.type);
    } else if (this.updateTargetFamily && this.updateTargetFamily.senderType == SenderType.LINE) {
      requestBody = this.createDeleteRequestBody(ReservationDeleteSendType.LINE, reservation.type);
    } else if (this.updateTargetFamily && this.updateTargetFamily.senderType == SenderType.MAIL) {
      requestBody = this.createDeleteRequestBody(ReservationDeleteSendType.MAIL, reservation.type);
    } else {
      requestBody = this.createDeleteRequestBody(ReservationDeleteSendType.NONE, reservation.type);
    }
    await this.reservationsService.delete(userStore, reservation.id, requestBody);

    this.isBusy = false;
    this.showConsentedCancelSuccessModal = true;

    // サイドメニューの未完了バッジを更新する
    this.$emit("refresh");

    // ページに表示する面会予約を取得しなおす
    this.items = [];
    await this.createView();

    return;
  }

  /**
   * ### 辞退のメッセージ入力ダイアログを表示する
   */
  public async onUnconsented(reservation: ReservationTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.updateTargetReservation = reservation;

    // 家族が存在する場合、LINEまたはメールを送信するので入力モーダルを表示する
    const family: FamilyGetModel | null = await this.getFamily(reservation.resident.id, reservation.family.id);
    if (family) {
      this.updateTargetFamily = family;
      this.setMessageModalTitleAndText(family, reservation, "辞退");

      this.isBusy = false;
      this.showUnconsentedRegisterModal = true;
    }
    // 家族が削除されていた場合、辞退・キャンセルの確認モーダルを表示する
    else {
      this.isBusy = false;
      this.showConfirmUnconsentedModal = true;
    }

    return;
  }

  /**
   * ### 家族を取得する
   *
   * - 家族単一を取得するAPIはないので、利用者にひもづく家族を取得する
   * - 家族の中から家族IDが同一のものを修正対象の家族と判断する
   * - 見つからなかった場合は404画面に遷移させたいので例外を投げる
   */
  public async getFamily(residentId: number, familyId: number): Promise<FamilyGetModel | null> {
    const families: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, residentId);
    for (const family of families) {
      if (family.familyId == familyId) {
        return family;
      }
    }
    return null;
  }

  /**
   * ### メッセージモーダルで表示する情報を格納する
   *
   * - モーダルのタイトル
   * - モーダルのメッセージ(説明文)
   * - メッセージのタイトル
   * - メッセージ本文
   *   - 送信対象の家族がLINEかメールかで本文の内容が異なる
   */
  public setMessageModalTitleAndText(family: FamilyGetModel, reservation: ReservationTableItem, operation: string): void {
    // 共通で使用する文字列
    const reservationType: string = reservation.type == ReservationType.VISIT ? "訪問面会" : "オンライン面会";
    const reservationDatetime: string = this.$dateUtil.convertNumberToString(reservation.datetime, "mm月dd日 hh:MM");

    // モーダルタイトル
    this.messageModalTitle = `${reservation.resident.name}（${reservation.resident.room}）様の`;
    this.messageModalTitle += `${reservation.family.name}（${reservation.family.relation}）の${reservationType}を${operation}しますか？`;

    // モーダルメッセージ(説明文)
    this.messageModalMessage = "ご家族へのメッセージ内容を編集して送信してください。\n送信すると面会予約が取り消されます。";

    // タイトル
    this.messageTitle = `${reservationType}の${operation}（${reservationDatetime}）`;

    // 本文の作成
    if (family.senderType == SenderType.LINE) {
      // LINEメッセージ送信
      this.messageText = `${userStore.facility.name}  ${family.name}様\n`;
      this.messageText += `${reservationDatetime}の${reservationType}の予約が施設のご都合により${operation}されました。\n\n`;
      this.messageText += `別の日程を選択して再度予約をお願いします。`;
    } else if (family.senderType == SenderType.MAIL) {
      // メール送信
      this.messageText = `HitomeQ コネクト のご家族向けメール配信サービスです。\n\n`;
      this.messageText += `${userStore.facility.name}のご都合により、${reservationType}の予約が${operation}されました。\n`;
      this.messageText += `予約日時: ${reservationDatetime}\n\n`;
      this.messageText += `別日程での再予約をご希望の場合は、${userStore.facility.name}へご連絡ください。\n\n\n`;
      this.messageText += `このメールへの返信はできませんのでご了承ください。\n`;
      this.messageText += `配信停止をご希望の場合は、ご利用の施設までご連絡ください。`;
    }

    return;
  }

  /**
   * ### 辞退確認ダイアログを表示する
   */
  public confirmUnconsented(): void {
    const reservation: ReservationTableItem = this.updateTargetReservation as ReservationTableItem;
    this.messageConfirmModalTitle = `${reservation.resident.name}（${reservation.resident.room}）様の`;
    this.messageConfirmModalTitle += `${reservation.family.name}（${reservation.family.relation}）に以下の内容でメッセージを送信します。よろしいですか？`;
    this.showUnconsentedRegisterConfirmModal = true;
    return;
  }

  /**
   * ### 辞退をAPI経由で登録する
   */
  public async unconsented(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "辞退中...";

    this.showUnconsentedRegisterConfirmModal = false;
    this.showUnconsentedRegisterModal = false;

    const reservation: ReservationTableItem = this.updateTargetReservation as ReservationTableItem;
    let requestBody: ReservationsDeleteModel | null = null;
    if (this.updateTargetFamily && this.updateTargetFamily.senderType == SenderType.LINE) {
      requestBody = this.createDeleteRequestBody(ReservationDeleteSendType.LINE, reservation.type);
    } else {
      requestBody = this.createDeleteRequestBody(ReservationDeleteSendType.MAIL, reservation.type);
    }
    await this.reservationsService.delete(userStore, reservation.id, requestBody);

    this.showUnconsentedSuccessModal = true;
    // サイドメニューの未完了バッジを更新する
    this.$emit("refresh");

    // ページに表示する面会予約を取得しなおす
    this.items = [];
    await this.createView();

    this.isBusy = false;

    return;
  }

  public createDeleteRequestBody(sendType: ReservationDeleteSendType, reservationType: ReservationType): ReservationsDeleteModel {
    return {
      title: this.messageTitle,
      text: this.messageText,
      reservationType: reservationType,
      sendType: sendType
    };
  }

  /**
   * ### その他の家族ユーザーにオンライン面会URLを送るために、宛先選択ダイアログを表示する
   */
  public async showMessageTargetModal(reservation: ReservationTableItem): Promise<void> {
    // 対象の面会予約を保持しておく
    this.updateTargetReservation = reservation;

    const modal: any = this.$refs.transferOnlineReservationSelectModal;
    modal.show();

    return;
  }

  /**
   * ### 送信確認ダイアログを表示する
   */
  public addSendTarget(target: OtherUserGroupTypeGroup) {
    if (target.memberLineId != undefined) {
      this.registerTarget = target;
      const sendMessageModal: TransferOnlineReservationModal | Vue | Element | Vue[] | Element[] = this.$refs.sendMessageModal;
      if (sendMessageModal instanceof TransferOnlineReservationModal) {
        sendMessageModal.show();
      }
    }

    return;
  }

  /**
   * ### メッセージを送信する
   */
  public async sendMessage(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "送信中...";

    // 登録用情報を作成し、APIにリクエストを送る
    const reservation: ReservationTableItem = this.updateTargetReservation as ReservationTableItem;

    const target: OtherUserGroupTypeGroup = this.registerTarget;
    const otherUserGroupsSortKeys: Array<string> = [target.otherUserGroupsSortKey];
    await this.reservationsService.transferOnlineReservationUrl(userStore, reservation.id, { otherUserGroupsSortKeys: otherUserGroupsSortKeys });

    this.showSendMessageSuccessModal = true;

    this.isBusy = false;

    return;
  }

  /**
   * ### 一括承諾ボタン押下イベント
   */
  public onMultipleConsented(): void {
    if (this.disableMultipleConsented) {
      return;
    }

    let multipleConsentedTargets: Array<ReservationTableItem> = [];
    for (const item of this.items) {
      if (item.select == true) {
        multipleConsentedTargets.push(item);
      }
    }
    this.multipleConsentedTargets = multipleConsentedTargets;

    this.showMultipleConsentedModal = true;

    return;
  }

  /**
   * ### 一括承諾実施
   */
  public async multipleConsented(): Promise<void> {
    try {
      console.log("consented start:", this.$dateUtil.convertDateToString(new Date(), "hh:MM.ss"));

      // プログレス付きモーダルを表示する
      // 進捗はファイルのアプロード状況を反映させるようにする
      this.currentConsentedCount = 0;
      this.consentedCount = this.multipleConsentedTargets.length;
      this.progressMessage = "一括承諾中。\n完了するまでそのままお待ちください。\n承諾中に別画面に遷移しますと処理がキャンセルされます。";
      this.progressLoading = true;

      // 承諾を実施する
      for (let i = 0; i < this.multipleConsentedTargets.length; i++) {
        this.currentConsentedCount = i;
        const requestBody: ReservationsConsentedPatchModel = {
          consented: true,
          consentedUserId: userStore.loginUser.userId,
          consentedUserName: userStore.loginUser.name,
          updated: Number(this.multipleConsentedTargets[i].updated)
        };
        await this.reservationsService.patchConsented(userStore, this.multipleConsentedTargets[i].id, requestBody);
      }

      this.progressLoading = false;
      this.showMultipleConsentedSuccessModal = true;

      console.log("consented end:", this.$dateUtil.convertDateToString(new Date(), "hh:MM.ss"));

      // サイドメニューの未完了バッジを更新する
      this.$emit("refresh");

      // ページに表示する面会予約を取得しなおす
      this.items = [];

      await this.createView();
    } catch (error) {
      const systemError: SystemError = error as SystemError;

      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw systemError;
      }
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    // 画面を離れる前に現在のフィルタリング条件をVuexに保存
    if (this.$options.name) {
      itemListFilterStore.setFilter({ url: this.$options.name, filter: this.filter });
    }
    next();
  }
}
</script>

<style lang="scss" scoped>
// 親要素からネストしてスタイルを指定する
#reservation-list {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  .note {
    margin: 0 0 8px 0;
  }
  .setting-btn {
    min-width: 100px;
  }
  .schedule-btn {
    min-width: 220px;
  }
  .register-btn {
    width: 98px;
  }
  .multiple-consented-btn {
    min-width: 100px;
  }

  .deleted-filter {
    min-width: 168px;
  }
  .word-search-filter {
    min-width: 336px;
  }
  .resident-group-filter {
    min-width: 295px;
  }
  .table-option-text {
    min-width: 113px;
  }
}
</style>
